// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"441d0d5c","404":"1ddfc903","510":"441beabf","885":"b541ad60"}[chunkId] + ".chunk.js";
};